export const REJECT_LABEL = "Stay";
export const CONFIRM_LABEL = "Leave";
export const PRICING_TEXT = "Pricing ID ";
export const TITLE_TEXT = "ICE PPE";
export const MODAL_TEXT = "Leave ICE PPE?";
export const MODAL_SUMMARY = "If you have unsaved changes they will be lost.";
export const HISTORICAL_PRICING_TEXT = "Currently Showing Historical Pricing";
export const LO_PAGE_TITLES = {
  "/search-form": "Search",
  "/search-results": "Results",
  "/lock-summary": "Summary",
};
export const SEC_PAGE_TITLES = {
  "/search-form": "Search Form",
  "/search-results": "Search Results",
  "/lock-summary": "Pricing",
};
